/*@flow*/
import type { Node } from 'react';
import React from 'react';
import Item from './Item';
import Checkbox from './Checkbox';
import isObject from 'lib/t/isObject';

type OptionT = {
  value: string,
  text: string,
  onChange: (any) => any,
};

type PropsT = {
  label: React$Node,
  options: OptionT[],
  value: any[],
  onChange: (any) => any,
  attrs: { name: string, id: string },
  hideWhen?: () => boolean,
};

export default function CheckboxGroup(locals: PropsT): null | Node {
  const { hideWhen, value, onChange, label, options, attrs } = locals;
  if (hideWhen && hideWhen()) return null;
  let v3 = value || [];
  v3 = isObject(v3) ? Object.keys(v3) : v3;

  const onChangeItem = (v2) => {
    const newValue = v3.includes(v2)
      ? v3.filter((v4) => v4 !== v2)
      : v3.concat(v2);
    onChange(newValue);
  };

  return (
    <Item label={label}>
      {options.map((v, i) => (
        <Checkbox
          value={v.value}
          text={v.text}
          key={i}
          name={attrs.name + '[]'}
          id={attrs.id + '-' + i}
          checked={v3.includes(v.value)}
          onChange={onChangeItem}
        />
      ))}
    </Item>
  );
}
